import useModal from "@/src-refactor/modules/shared/components/refactor/base/modal/useModal";
import MxModalTemplate from "@rf-l1/modal/MxModalTemplate";
import MxTypography from "@rf-l1/MxTypography";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextAreaField from "@rf-l2/form/text-fields/MxFormTextAreaField";
import { useDeclineDocumentMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { Button, Grid } from "@mui/material";
import { Form, Formik, FormikConfig } from "formik";
import toast from "react-hot-toast";
import { object, string } from "yup";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";

const OppositionCommendToDocuments = () => {
  const [DECLINE_M] = useDeclineDocumentMutation();
  const { onConfirm, getData } = useModal();
  const data = getData() as any;
  const FormikForm: FormikConfig<any> = {
    enableReinitialize: true,

    initialValues: {
      comment: ""
    },
    onSubmit: (values: any) => {
      const request = DECLINE_M({
        body: {
          validation_document_id: data?.id,
          comment: values.comment
        }
      }).unwrap();
      return toast
        .promise(request, {
          loading: "Enviando...",
          success: "Enviado",
          error: "Error al enviar"
        })
        .then(() => {
          onConfirm();
        });
    },
    validationSchema: object().shape({
      comment: string()
        .min(5, "El mínimo es de 5 caracteres")
        .required("El comentario es requerido")
    })
  };
  return (
    <Grid container>
      <Grid item xs={12} justifyContent={"center"}>
        <MxTypography variant="caption" color="gray" fontWeight={400}>
          Escribir motivo de rechazo del documento {data?.document}
        </MxTypography>
      </Grid>
      <Grid item xs={12} justifyContent={"center"} my={2}>
        <Formik {...FormikForm} isInitialValid>
          {formikProps => {
            return (
              <Form>
                <Grid container>
                  <Grid item xs={12}>
                    <MxFormFieldController name="comment">
                      <MxFormTextAreaField
                        name="comment"
                        placeholder="Escriba un justificante"
                      />
                      <MxFormErrorMessage />
                    </MxFormFieldController>
                  </Grid>
                  <Grid container item xs={12} justifyContent={"flex-end"} mt={2}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{
                        borderRadius: "50px",
                        fontSize: 12,
                        fontWeight: 500
                      }}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );
};

const OppositionCommendToDocumentsTemplate = () => {
  return <MxModalTemplate2 children={<OppositionCommendToDocuments />} />;
};

export default OppositionCommendToDocumentsTemplate;
